import { Systems } from "@/fhir/enums/systems";

/** Coding system for eligibility-list membership tags on Appointment.meta.tag. */
export const ELIGIBILITY_LIST_STATUS_SYSTEM = `${Systems.QH}/fhir/CodeSystem/eligibility-list-status`;

/** Tag code written when a biller removes an appointment from the eligibility list. */
export const ELIGIBILITY_LIST_STATUS_EXCLUDED_CODE = "excluded";

/** FHIR `_tag:not` token so appointment search omits tag-excluded rows. */
export const ELIGIBILITY_LIST_EXCLUDED_TAG_TOKEN = `${ELIGIBILITY_LIST_STATUS_SYSTEM}|${ELIGIBILITY_LIST_STATUS_EXCLUDED_CODE}`;
